/** This slice is for variables related to google APIs. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isGoogleFetchingToken: false,
	googleAccessToken: '',
	googleRefreshToken: '',
};

export const googleApiSlice = createSlice({
	name: 'google',
	initialState: initialState,
	reducers: {
		setIsGoogleFetchingToken: (state, action) => {
			if (typeof action.payload !== 'boolean')
				console.warn(
					'You provided a non-boolean payload to setIsGoogleFetchingToken'
				);
			state.isGoogleFetchingToken = !!action.payload;
		},
		setGoogleAccessToken: (state, action) => {
			if (typeof action.payload !== 'string')
				console.warn(
					'You provided a non-string payload to setGoogleAccessToken'
				);
			state.googleAccessToken = String(action.payload);
		},
		setGoogleRefreshToken: (state, action) => {
			if (typeof action.payload !== 'string')
				console.warn(
					'You provided a non-string payload to setGoogleRefreshToken'
				);
			state.googleRefreshToken = String(action.payload);
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setIsGoogleFetchingToken,
	setGoogleAccessToken,
	setGoogleRefreshToken,
	setGoogleNextMediaPageToken,
	setGoogleNextAlbumPageToken,
} = googleApiSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectIsGoogleFetchingToken = (state) =>
	state.google.isGoogleFetchingToken;
export const selectGoogleAccessToken = (state) =>
	state.google.googleAccessToken;
export const selectGoogleRefreshToken = (state) =>
	state.google.googleRefreshToken;

export default googleApiSlice.reducer;
